import { ApdmCampaignVersionRef } from './campaign';

function object(
  value: unknown,
  fields: string[],
): Record<string, unknown> | null {
  if (
    !value ||
    typeof value !== 'object' ||
    Array.isArray(value) ||
    Object.getPrototypeOf(value) !== Object.prototype
  )
    return null;
  const row = Object.fromEntries(Object.entries(value));
  return Object.keys(row).some(key => !fields.includes(key)) ||
    fields.some(key => !(key in row))
    ? null
    : row;
}
export function parseApdmCampaignPreviewWidgetPayload(
  value: unknown,
): ApdmCampaignVersionRef | null {
  const row = object(value, ['campaignId', 'expectedVersion']);
  if (
    !row ||
    typeof row.campaignId !== 'string' ||
    !/^apc_[a-z0-9]{26}$/.test(row.campaignId) ||
    typeof row.expectedVersion !== 'number' ||
    !Number.isSafeInteger(row.expectedVersion) ||
    row.expectedVersion < 1 ||
    row.expectedVersion > 2147483646
  )
    return null;
  return { campaignId: row.campaignId, expectedVersion: row.expectedVersion };
}
/** The coupon widgets name the draft; the app reads its current coupon. */
export function parseApdmCouponWidgetPayload(
  value: unknown,
): ApdmCampaignVersionRef | null {
  return parseApdmCampaignPreviewWidgetPayload(value);
}
export function parseApdmImportMappingWidgetPayload(
  value: unknown,
): { importId: string } | null {
  const row = object(value, ['importId']);
  if (
    !row ||
    typeof row.importId !== 'string' ||
    !/^pdi_[a-z0-9]{26}$/.test(row.importId)
  )
    return null;
  return { importId: row.importId };
}
